/**
 * Rooster plugin that blocks pasting an image into the editor
 */ export class RoosterBlockDnDPlugin {
    /**
     * Gets the name of the plugin
     */ getName() {
        return "RoosterBlockDnDPlugin";
    }
    /**
     * Plugin initialize lifecycle hook
     */ initialize(editor) {
        editor.addDomEventHandler("drop", (event)=>{
            event.preventDefault();
        });
    }
    /**
     * Plugin dispose lifecycle hook
     */ dispose() {
    /* do nothing */ }
    /**
     * Plugin event hook
     */ onPluginEvent(event) {
    /* do nothing */ }
}
